import React, { useState } from "react";
import { Tooltip, Descriptions } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import Logger from "@/utility/logger";

function ProjectDetails({
  selectedProject,
  selectedReportTemplate,
  projectDetailsExpanded,
  setProjectDetailsExpanded,
  projectPlaceholderDetails,
}) {
  // Both lists are resolved by Home with a `.find()`, so either can be
  // undefined while they load (or if a fetch failed). Dereferencing them used
  // to throw here and unmount the entire taskpane into a blank pane, so the
  // component now renders nothing until both are present.
  const targetTemplate =
    selectedProject && selectedReportTemplate
      ? selectedProject?.report_templates?.find((template) => template.id === selectedReportTemplate.id)
      : undefined;

  if (!selectedProject || !selectedReportTemplate) {
    Logger.debug("ProjectDetails.tsx: Waiting for project and report template to load.");
    return null;
  }

  let finalPlaceholderValues = [];

  const extractedPlaceholderDetails = Object.values(projectPlaceholderDetails).filter(
    (item) => typeof item === "object" && item !== null && "key" in item && "label" in item && "type" in item
  );

  if (targetTemplate && targetTemplate?.placeholder_values) {
    const sourceValues = targetTemplate?.placeholder_values;

    finalPlaceholderValues = extractedPlaceholderDetails?.map((placeholder: any) => {
      const key = placeholder?.key;

      return {
        key: key,
        label: placeholder?.label,
        value: sourceValues[key] || "",
      };
    });
  } else {
    Logger.debug("ProjectDetails.tsx: No matching template or placeholder values found for the selected report.");
  }

  return (
    <div className="project_details_content">
      <Descriptions layout="horizontal" column={1} size="small" bordered>
        <Descriptions.Item
          label={
            <span
              style={{ cursor: "pointer", userSelect: "none" }}
              onClick={() => setProjectDetailsExpanded(!projectDetailsExpanded)}
            >
              {projectDetailsExpanded ? (
                <Tooltip autoAdjustOverflow title="Hide Project Details">
                  <DownOutlined />
                  <span className="project_details_span">Project</span>
                </Tooltip>
              ) : (
                <Tooltip autoAdjustOverflow title="Show Project Details">
                  <RightOutlined />
                  <span className="project_details_span">Project</span>
                </Tooltip>
              )}
            </span>
          }
          className="project_details_label"
        >
          <p className="project_details_value">{selectedProject?.name}</p>
        </Descriptions.Item>
        {projectDetailsExpanded && (
          <>
            <Descriptions.Item label="Report" className="project_details_label">
              <p className="project_details_value">{selectedReportTemplate?.name}</p>
            </Descriptions.Item>

            {finalPlaceholderValues?.map((item) => (
              <Descriptions.Item label={item.label} key={item.key} className="project_details_label">
                <p className="project_details_value">{item.value}</p>
              </Descriptions.Item>
            ))}
          </>
        )}
      </Descriptions>
    </div>
  );
}

export default ProjectDetails;
